<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    :width="width"
    :height="height"
  >
    <path d="M21 14H27C27.5304 14 28.0391 13.7893 28.4142 13.4142C28.7893 13.0391 29 12.5304 29 12V6C29 5.46957 28.7893 4.96086 28.4142 4.58579C28.0391 4.21071 27.5304 4 27 4H21C20.4696 4 19.9609 4.21071 19.5858 4.58579C19.2107 4.96086 19 5.46957 19 6V8H18C16.9391 8 15.9217 8.42143 15.1716 9.17157C14.4214 9.92172 14 10.9391 14 12V15H10V14C10 13.4696 9.78929 12.9609 9.41421 12.5858C9.03914 12.2107 8.53043 12 8 12H4C3.46957 12 2.96086 12.2107 2.58579 12.5858C2.21071 12.9609 2 13.4696 2 14V18C2 18.5304 2.21071 19.0391 2.58579 19.4142C2.96086 19.7893 3.46957 20 4 20H8C8.53043 20 9.03914 19.7893 9.41421 19.4142C9.78929 19.0391 10 18.5304 10 18V17H14V20C14 21.0609 14.4214 22.0783 15.1716 22.8284C15.9217 23.5786 16.9391 24 18 24H19V26C19 26.5304 19.2107 27.0391 19.5858 27.4142C19.9609 27.7893 20.4696 28 21 28H27C27.5304 28 28.0391 27.7893 28.4142 27.4142C28.7893 27.0391 29 26.5304 29 26V20C29 19.4696 28.7893 18.9609 28.4142 18.5858C28.0391 18.2107 27.5304 18 27 18H21C20.4696 18 19.9609 18.2107 19.5858 18.5858C19.2107 18.9609 19 19.4696 19 20V22H18C17.4696 22 16.9609 21.7893 16.5858 21.4142C16.2107 21.0391 16 20.5304 16 20V12C16 11.4696 16.2107 10.9609 16.5858 10.5858C16.9609 10.2107 17.4696 10 18 10H19V12C19 12.5304 19.2107 13.0391 19.5858 13.4142C19.9609 13.7893 20.4696 14 21 14ZM8 18H4V14H8V18ZM21 20H27V26H21V20ZM21 6H27V12H21V6Z" />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: 32,
    },
    height: {
      type: [Number, String],
      default: 32,
    },
  },
}
</script>

